import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import { Menu } from '@headlessui/react'
import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { FloatingPortal, useFloating } from '@floating-ui/react'

type DropdownItem = {
  content: ReactNode
  className: string
  href?: string
  show?: boolean
  onClick?: () => void
}

type EllipsisDropdownMenuProps = {
  items: DropdownItem[]
}

const EllipsisDropdownMenu: React.FC<EllipsisDropdownMenuProps> = ({
  items,
}) => {
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-end',
  })

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button
        className="flex items-center rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-100"
        ref={refs.setReference}
      >
        <span className="sr-only">Open options</span>
        <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
      </Menu.Button>

      <FloatingPortal root={document.getElementById('portal')}>
        <Menu.Items
          ref={refs.setFloating}
          className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          style={floatingStyles}
        >
          <div className="py-1">
            {items
              .filter(item => item.show || item.show === undefined)
              .map((item, index) => (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <a
                      href={item.href}
                      onClick={item.onClick}
                      className={classNames(
                        active ? 'bg-gray-100' : '',
                        item.className,
                        'block px-4 py-2 text-sm leading-5 font-normal'
                      )}
                    >
                      {item.content}
                    </a>
                  )}
                </Menu.Item>
              ))}
          </div>
        </Menu.Items>
      </FloatingPortal>
    </Menu>
  )
}

export default EllipsisDropdownMenu
